import type {
  InquirySelectFieldProps,
  InquiryTextFieldProps,
} from '../constants/inquiries'

export function InquiryTextField({
  id,
  label,
  required = false,
  type = 'text',
  placeholder,
  value,
  autoComplete,
  disabled,
  onChange,
}: InquiryTextFieldProps) {
  return (
    <div className="inquiry-field">
      <label htmlFor={id}>
        {label}
        {required ? <span aria-hidden="true"> *</span> : null}
      </label>
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}

export function InquirySelectField({
  id,
  label,
  required = false,
  value,
  placeholder,
  options,
  disabled,
  onChange,
}: InquirySelectFieldProps) {
  return (
    <div className="inquiry-field">
      <label htmlFor={id}>
        {label}
        {required ? <span aria-hidden="true"> *</span> : null}
      </label>
      <select
        id={id}
        value={value}
        required={required}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
